import React from 'react'
import { Button } from '@mc/design-system'
import { EnhancedCtaCopy } from '@mc/growth'
import classes from './BannerContent.module.scss'

type WithChildren = {
  children: React.ReactNode
}

export const BannerContent = ({ children }: WithChildren) => (
  <div className='d-flex flex-column flex-md-row align-items-center justify-content-center mc-px-4 mc-py-3'>
    {children}
  </div>
)

const Title = ({ children: title }: WithChildren) => (
  <>
    {/* Desktop */}
    <div className='d-none d-lg-block'>
      <h2 className='mc-mr-4 mc-text-h3 mc-text--brand mc-text--uppercase'>
        {title}
      </h2>
    </div>

    {/* Tablet */}
    <div className='d-none d-md-block d-lg-none'>
      <h2
        className={`mc-mr-4 mc-text-h2 mc-text--brand mc-text--uppercase ${classes.mdTitle}`}
      >
        {title}
      </h2>
    </div>

    {/* Mobile */}
    <div className='d-block d-md-none'>
      <h2
        className='mc-text--brand mc-text--uppercase mc-px-1 mc-text--center'
        style={{ fontSize: '28px' }}
      >
        {title}
      </h2>
    </div>
  </>
)

BannerContent.Title = Title

const Subtitle = ({ children: subtitle }: WithChildren) => (
  <div className='mc-text-h8 mc-opacity--hinted mc-text--uppercase'>
    {/* Tablet & Desktop */}
    <div className='d-none d-md-block'>
      <p className='mc-mr-4 d-inline-flex'>{subtitle}</p>
    </div>

    {/* Mobile */}
    <div className='d-block d-md-none'>
      <p className='d-block mc-text--center mc-mt-3'>{subtitle}</p>
    </div>
  </div>
)

BannerContent.Subtitle = Subtitle

type CTAProps = {
  ctaHref: string
  onCtaClick(): void
  children: string // only support string as CTA button child
}

const CTA = ({ ctaHref, onCtaClick, children: ctaText }: CTAProps) => (
  <>
    {/* Tablet & Desktop */}
    <div className='d-none d-md-block'>
      <Button render={<a href={ctaHref} />} onClick={onCtaClick} size='sm'>
        <EnhancedCtaCopy size='sm'>{ctaText}</EnhancedCtaCopy>
      </Button>
    </div>

    {/* Mobile */}
    <div className='d-block d-md-none'>
      <Button
        render={<a href={ctaHref} />}
        onClick={onCtaClick}
        size='sm'
        className='mc-py-2 mc-mt-3'
      >
        <EnhancedCtaCopy size='sm'>{ctaText}</EnhancedCtaCopy>
      </Button>
    </div>
  </>
)

BannerContent.CTA = CTA
